<template>
  <aside class="sidebar">
    <ul class="sidebar__list">
      <router-link
        v-for="route in routes"
        :key="route.name"
        custom
        v-slot="{ href, isActive, navigate }"
        :to="{
          name: route.name,
        }"
      >
        <li role="link" @click="navigate" @keypress.enter="navigate">
          <a
            class="sidebar__item"
            :class="{ 'sidebar__item--active': isActive }"
            :href="href"
          >
            {{ route.title }}
          </a>
        </li>
      </router-link>
    </ul>
  </aside>
</template>

<script>
import { ref } from "vue";

export default {
  setup() {
    const routes = ref([
      { name: "services", title: "Услуги" },
      { name: "applications", title: "Заявления" },
      { name: "documents", title: "Документы" },
      { name: "gisogd", title: "ГИСОГД" },
      { name: "objects", title: "Объекты" },
    ]);

    return {
      routes,
    };
  },
};
</script>

<style>
.sidebar {
  padding-top: 25px;
  overflow-y: auto;
}

.sidebar__list {
  margin: 0;
  padding: 0;
  list-style: none;
  min-width: 260px;
}
.sidebar__item {
  display: block;
  color: var(--primary-blue-lighter);
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: var(--padding-container-desktop);
  font-size: 16px;
  line-height: 120%;
  min-height: 19px;
  border-radius: 0px 6px 6px 0px;
}

.sidebar__item:active,
.sidebar__item--active {
  color: var(--basic-white);
  background-color: var(--primary-blue-lighter);
}

.sidebar__item:hover,
.sidebar__item:hover.sidebar__item--active {
  color: var(--basic-white);
  background-color: var(--primary-blue-light);
}

.sidebar__item:focus {
  color: var(--basic-white);
  background-color: var(--primary-blue);
  outline: none;
}
</style>
